import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of} from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class BaseService {
    public static env = environment.production;
    public static esbManagerGetUrl = environment.esb_managerbyemail_url;
    public static esbStaffGetUrl = environment.esb_staff_url;
    public static staffActivityGetUrl = environment.staff_activity_get;
    public static publicAccessKey = environment.public_access_key;

    protected managerKey = null;
    protected managerId = null;
    constructor(
        protected cookieService: CookieService,
        protected http: HttpClient) {
        //this.managerKey = this.cookieService.get('tok');
        this.managerKey = localStorage.getItem('tok');
    }

    protected handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            this.log(error);
            return of(result as T);
        };
    }

    protected log(message: string) {
        if (!BaseService.env) {
            console.log(message);
        }
    }

    public getWeekEnding(dateSelected: any) {
        let dateArr;
        let date;
        let dayOfTheWeek;
        let diffToSaturday = 0;
        let maxDaysOfTheMonth = 0;
        let dayNumeric = 0;

        const day = dateSelected.getDate();
        const month = dateSelected.getMonth() + 1;
        const year = dateSelected.getFullYear();
        // parsing day in an array 0-month, 1-day of the month, 2- year
        dateArr = {
            month,
            day,
            year
        };

        dayNumeric = parseInt(dateArr.day, null);
        date = new Date();
        // parsing in a date var in order to get day of the week
        date.setYear(dateArr.year);
        date.setMonth(dateArr.month - 1, dayNumeric);
        dayOfTheWeek = date.getDay();
        diffToSaturday = (dayOfTheWeek !== 6 ? 6 - dayOfTheWeek : 0);
        // checking end of month
        maxDaysOfTheMonth = this.daysInMonth(date);
        // calculate days neede to be on saturdar
        if (dayNumeric + diffToSaturday > maxDaysOfTheMonth) {
            dateArr.month = parseInt(dateArr.month, null) + 1;
            // calculate the days for the next month
            diffToSaturday = diffToSaturday - (maxDaysOfTheMonth - parseInt(dateArr.day, null));
            dateArr.day = diffToSaturday;
            // the day set in the array belongs to the saturday, no difference to get it
            diffToSaturday = 0;
        }
        // initializing variable to get the new date
        date = new Date();
        // setting new date based on the difference for saturday
        date.setMonth(dateArr.month - 1, parseInt(dateArr.day, null) + diffToSaturday);
        date.setYear(dateArr.year);

        return date;
    }

    public daysInMonth(anyDateInMonth) {
        return new Date(anyDateInMonth.getFullYear(), anyDateInMonth.getMonth() + 1, 0).getDate();
    }
}
